export default __webpack_public_path__ + "static/media/dont_overexpose.2a32eca6.png";